export default "__VITE_ASSET__f215f325__"